/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import TextField from "@mui/material/TextField";
import Button from "../../components/ButtonUse.jsx";
import { useEffect, useState } from "react";
import Select from "react-select";
import tempImage from "../../assets/images/clothes.avif";
import placeholder from "../../assets/images/placeholder.png";

import ModalComponent from "components/MDTypography/ModalComponent";
import { EditCategory } from "./EditCategory.1";
import axios from "axios";
window.Buffer = window.Buffer || require("buffer").Buffer;


export default EditCategory;

export function GeneralDetailsForm({
  options,
  selectedCategory,
  setSelectedCategory,
  data,
  setFunc,
  isBodyData,
  setIsBodyData,
}) {
  // console.log(selectedCategory);

  const GenerateCategoryInputs = ({ inputValue }) => {
    // Split the input value into an array
    const value_split = inputValue ? inputValue.value.split("/") : [];
    const [inputValues, setInputValues] = useState(value_split);
    // Use useEffect to update state when inputValue changes
    useEffect(() => {
      setInputValues(value_split);
    }, [inputValue]);

    // Define labels based on the index
    const labels = ["Parent", "Child", "Inner Child", "Inner Inner Child"];

    // Handle input value change
    const handleInputChange = (index, newValue) => {
      const newValues = [...inputValues];
      console.log(newValues);
      newValues[index] = newValue;
      setInputValues(newValues);
    };
    useEffect(() => {
      setFunc({ ...data, subCategories: inputValues });
      // setFunc({ ...data, categoryName: selectedCategory.value })
    });
    // Map over the array and create input elements with labels
    const inputElements = value_split.map((value, index) => (
      <div className="flex flex-col gap-4" key={index}>
        <label>{labels[index]}</label>
        <input
          className="w-[60vw] h-[6vh] pl-4"
          value={value}
          type="text"
          onChange={(e) => handleInputChange(index, e.target.value)}
        />
      </div>
    ));

    return (
      <>
        <div>{inputElements}</div>
      </>
    );
  };

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column", marginTop: "3vh" }}>
          {/* <label>Category Name</label> */}
          {console.log(data, "DDDAAA")}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw",
            '& .Mui-disabled': {
              color: '#000000', // Text color
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#00000', // Border color
              },
              
            }, }}
            label="Category Name"
            disabled
            // variant="outlined"
            value={data?.categoryName}
            // defaultValue={"Мужчинам"}
            // value={categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
          />

          {/* <Select
                        options={options}
                        defaultValue={selectedCategory}
                        onChange={setSelectedCategory}
                    />
                    {selectedCategory && <GenerateCategoryInputs inputValue={selectedCategory} />} */}


                    {/* <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Description*</span>
                        <textarea
                            placeholder="write description"
                            style={{ width: "60vw", padding: "10px" }}
                            name=""
                            id=""
                            value={data?.description}
                            onChange={(e) => setFunc({ ...data, description: e.target.value })}
                            cols="30"
                            rows="10"
                        ></textarea>
                    </div> */}
                    {console.log(data?.showORNot,'SSSSSSS')}
                    <div className="flex gap-2 flex-col">
                        <span className="text-sm font-semibold">isBodyData?</span>
                        <select value={data?.showORNot} onChange={(e) =>setFunc({ ...data, showORNot: e.target.value })} className="h-[4vh] w-[12vw]">
                            <option value="">Select</option>
                            <option value="1" >1</option>
                            <option value="0" >0</option>
                        </select>
                    </div>
                </div>
            </div>
        </>
    );
}


export function DataForm({
  data,
  setFunc,
  preview,
  selectedFile,
  handleChange,
  showImgUpload,
  setShowImgUpload,
}) {
  const handleShowImage = () => {
    setShowImgUpload(true);
  };

  const handleRemoveimg = () => {
    setShowImgUpload(false);
  };
  const statusOptions = [
    {
      value: "Enabled",
      label: "Enabled",
    },
    {
      value: "Disabled",
      label: "Disabled",
    },
  ];
  const [statuVal, setStatusVal] = useState(null);
  useEffect(() => {
    if (statuVal) {
      setFunc({ ...data, status: statuVal.value });
    }
  }, [statuVal]);
  const [imagePaths, setImagePaths] = useState([]);
  useEffect(() => {
    setImagePaths(data.categoryImage);
  },[data.categoryImage])

 
 



  const handleImagePathAdd=async(event) => {
    console.log(event.target.files,'iiiiiiiiiiiiiiii1111111111')
    const file = event.target.files;
    const formDataFile=new FormData();
    // formDataFile.append('images',file);
    // debugger
    for (let i = 0; i < file.length; i++) {
      formDataFile.append('images', file[i]);
    }
    const resp=await axios.post(`${process.env.REACT_APP_BASE_URL}/products/uploadProductImage`,formDataFile);
    console.log(resp.data[0],'iiiiiiiiiiiiii')
    {console.log(imagePaths,'imagessssssssssssssssssssssssssssss');}
    // const updatedImagePaths = [];
    // for (let i = 0; i < resp.data.data.length; i++) {
    //   // formDataFile.append('images', file[i]);
    //   // setImagePaths([...imagePaths,resp.data.data]);
    //   updatedImagePaths.push(resp.data.data[i]);
    // }

    setImagePaths(resp.data.data[0]);
    setFunc({...data,categoryImage: resp.data.data[0]})

  }

//   useEffect(() => {
//     if (_id) {
//       fetchData(_id);
//     }
//     console.log(_id, "ddddddddddddddd");
//   }, [location.state?.productId, _id]);

  return (
    <>
      <div style={{ padding: "5px", paddingBottom: "10vh" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
        <div className="flex flex-col mt-4 gap-4">
          <span className="text-sm">Add Image</span>
          <div className="flex flex-row flex-wrap gap-3">
           { console.log(imagePaths,'9999999999999')}
            {/* {imagePaths.map((path, idx) => ( */}
              <div className="flex flex-col gap-2 relative" >
                <div className="image-container relative">
                  {imagePaths?<img
                    src={imagePaths}
                    alt={`Image ${ 1}`}
                    style={{ width: "70px", height: "100px", margin: "5px" }}
                  />:null}
                  {/* <CloseIcon
                    className="text-xl cursor-pointer text-red-700 absolute top-0 right-0"
                    onClick={() => removeImageHandler(idx)}
                    style={{ width: "15px" }}
                  /> */}
                </div>
              </div>
            {/* ))} */}
             {/* <span className="text-sm">Choose Video</span> */}
          <label htmlFor="cate_img" style={{ display:"flex",alignItems:"center"}}>
            <img
              className="rounded-md"
              style={{
                width: "100px",
                height: "40px",
                objectFit: "contain",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              src={placeholder}
              alt="tempImage"
            />
            <input
              type="file"
              onChange={handleImagePathAdd}
              id="cate_img"
              multiple
              // accept="image/jpg,video/x-m4v,video/*"
              className="hidden"
            />
          </label>
          </div>
        </div>
          {/* {!showImgUpload && (
            <div>
              <Button
                cliclHandler={handleShowImage}
                type={"button"}
                background={"green"}
                title={"Add Image"}
              />
            </div>
          )}

          {showImgUpload && (
            <div className="flex flex-col  w-[20vw] items-start justify-start">
              <span>Category Image</span>

              <label className="" htmlFor="profile_pic">
                <img
                  className="ml-[-5vw]"
                  style={{ width: "20vw", height: "20vh", objectFit: "contain", cursor: "pointer" }}
                  src={preview ? preview : tempImage}
                  alt="temp_img"
                />
              </label>
              <input
                id="profile_pic"
                style={{ display: "none" }}
                type="file"
                accept="image/*"
                onChange={handleChange}
              />
              <div className="flex">
                <Button type={"button"} title={"Remove Image"} cliclHandler={handleRemoveimg} />
              </div>
            </div>
          )} */}

          {/* <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                        <span>Pinned</span>
                        <input
                            checked={data?.pinned}
                            onChange={(e) => setFunc({ ...data, pinned: !data.pinned })}
                            style={{ cursor: "pointer" }}
                            type="checkbox"
                        />
                    </div> */}

          {/* <TextField
                        id="outlined-basic"
                        sx={{ width: "60vw" }}
                        label="Sort Order"
                        variant="outlined"
                        value={data?.sortOrder}
                        onChange={(e) => setFunc({ ...data, sortOrder: e.target.value })}
                    /> */}

          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Minimal Weight"
            variant="outlined"
            value={data?.minimalWeight}
            onChange={(e) => setFunc({ ...data, minimalWeight: e.target.value })}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Minimal Size"
            variant="outlined"
            value={data?.minimalSize}
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, minimalSize: e.target.value });
              }
            }}
          />
          <div className="flex flex-col gap-3">
            <span className="text-sm font-semibold">Delivery By Train</span>
            <select
              value={data?.deliveryByTrain}
              onChange={(e) => setFunc({ ...data, deliveryByTrain: e.target.value })}
              className="w-[12vw] h-[6vh]"
            >
              <option value="">Select</option>
              <option>1</option>
              <option>0</option>
            </select>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-sm font-semibold">Delivery By Air</span>
            <select
              value={data?.deliveryByAir}
              onChange={(e) => setFunc({ ...data, deliveryByAir: e.target.value })}
              className="w-[12vw] h-[6vh]"
            >
              <option value="">Select</option>
              <option>1</option>
              <option>0</option>
            </select>
          </div>
          {/* <TextField
                        id="outlined-basic"
                        sx={{ width: "60vw" }}
                        label="Delivery By Air "
                        variant="outlined"
                        value={data?.minimalWeight}
                        onChange={(e) => setFunc({ ...data, minimalWeight: e.target.value })}
                    /> */}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Percentage of Profit"
            variant="outlined"
            value={data?.Profit}
            onChange={(e) => setFunc({ ...data, Profit: e.target.value })}
          />

          <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
            <span>Status</span>
            <Select options={statusOptions} onChange={setStatusVal} />
          </div>
        </div>
      </div>
    </>
  );
}

export function SeoForm({ data, setFunc }) {
  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Meta Tag"
            // placeholder="Exmples"
            value={data?.metaTag}
            onChange={(e) => setFunc({ ...data, metaTag: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Meta Title"
            // placeholder="Exmples"
            value={data?.metaTitle}
            onChange={(e) => setFunc({ ...data, metaTitle: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Meta Description"
            // placeholder="Exmples"
            value={data?.metaDescription}
            onChange={(e) => setFunc({ ...data, metaDescription: e.target.value })}
            variant="outlined"
          />
        </div>
      </div>
    </>
  );
}

export function BodyDataForm({ bodyData, setBodyData ,data,setFunc}) {
  console.log(data,'DATAAAA')
  return (
    <>
      <div className="p-4">
        <div className="flex flex-col gap-6">
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Gender</span>
              <select className="h-[4vh] w-[12vw]" 
                value={data?.Gender?data?.Gender:0}
                onChange={(e) => setFunc({ ...data, Gender: e.target.value })}
                
                >
                
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="0">0</option>
              </select>
            </div>

            <div className="flex gap-2 flex-col">
              <span className="text-sm">Height</span>
              <select className="h-[4vh] w-[12vw]" 
              value={data?.Height?data?.Height:0}
              onChange={(e) => setFunc({ ...data, Height: e.target.value })}
              >
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="0" >0</option>
              </select>
            </div>
          </div>
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Weight</span>
              <select className="h-[4vh] w-[12vw]"
                onChange={(e) => setFunc({ ...data, Weight: e.target.value })}
               value={data?.Weight?data?.Weight:0} >
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="0">0</option>
              </select>
            </div>

            <div className="flex gap-2 flex-col">
              <span className="text-sm">Shoulder</span>
              <select className="h-[4vh] w-[12vw]" 
                value={data?.Shoulder?data?.Shoulder:0}
                onChange={(e) => setFunc({ ...data, Shoulder: e.target.value })}
                >
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="0">0</option>
              </select>
            </div>
          </div>
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Waist</span>
              <select className="h-[4vh] w-[12vw]" 
                value={data?.Waistline?data?.Waistline:0}
                onChange={(e) => setFunc({ ...data, Waistline: e.target.value })}
                >
                <option value="">Select</option>
                <option  value="1">1</option>
                <option  value="0">0</option>
              </select>
            </div>

            <div className="flex gap-2 flex-col">
              <span className="text-sm">Chest</span>
              <select className="h-[4vh] w-[12vw]" 
                value={data?.Chest?data?.Chest:0}
                onChange={(e) => setFunc({ ...data, Chest: e.target.value })}
                >
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="0">0</option>
              </select>
            </div>
          </div>
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Age</span>
              <select className="h-[4vh] w-[12vw]" 
                value={data?.Age?data?.Age:0}
                onChange={(e) => setFunc({ ...data, Age: e.target.value })}
                >
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="0">0</option>
              </select>
            </div>

            <div className="flex gap-2 flex-col">
              <span className="text-sm">Hip</span>
              <select className="h-[4vh] w-[12vw]"  
                value={data?.Hip?data?.Hip:0}
                onChange={(e) => setFunc({ ...data, Hip: e.target.value })}
                >
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="0">0</option>
              </select>
            </div>
          </div>
          <div className="flex gap-20">
            <div className="flex gap-2 flex-col">
              <span className="text-sm">Foot</span>
              <select className="h-[4vh] w-[12vw]"  
                value={data?.Foot?data?.Foot:0}
                onChange={(e) => setFunc({ ...data, Foot: e.target.value })}
                >
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="0">0</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
